import {AbstractRepository} from './AbstractRepository'
import 'core-js/es6/array';

export class TagRepository extends AbstractRepository {
    tags;

    constructor() {
        super();
        this.tags = this.table('tags');
    }

    findAll() {
        return new Promise(resolve => {
            this.transaction('rw', this.tags, () => {
                this.tags = this.tags.toArray();
                resolve(this.tags);
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    addChildsToTags(allTags){
        let tagsFirstLevel = allTags.filter(function (filterTag) {
            return filterTag.parent === 0;
        });
        let tagsWithChilds = [];
        tagsFirstLevel.forEach(function(tag){

            tag.childs = allTags.filter(function (filterTag) {
                return filterTag.parent === this.id;
            }, tag);

            let childTags = [];

            tag.childs.forEach(function(childTag){
                childTag.childs = allTags.filter(function (filterTag) {
                    return filterTag.parent === this.id;
                }, childTag);
                childTags.push(childTag);
            });
            tag.childs = childTags;
            tagsWithChilds.push(tag);
        });

        return tagsWithChilds;
    }

    addChildsToTag(tag) {
        return new Promise(resolve => {
            let thisClass = this;
            let firstLevelPromise = new Promise(resolve => {
                this.transaction('r', this.tags, async () => {
                    let childs = this.tags.
                    where({parent: tag.id}).
                    toArray();

                    //childs = childs.sort((n1,n2)=> n1.title > n2.title);
                    resolve(childs);
                }).catch(e => {
                    alert(e.stack || e);
                });
            });
            firstLevelPromise.then(function(childs) {
                let childsWithChilds = [];

                childs.forEach(function (tag) {
                    let childPromise = thisClass.addChildsToTag(tag);
                    childPromise.then(function (childs) {
                        tag.childs = childs;
                        childsWithChilds.push(tag);
                    });
                });
                resolve(childsWithChilds);
            });
        })
    }

    findByTitleAndParent(title, parent) {
        return new Promise(resolve => {
            this.transaction('rw', this.tags, async () => {
                var tag = this.tags.
                where({title: title, parent: parent}).
                toArray();
                resolve(tag);
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    add(title, parent) {
        return new Promise(resolve => {
            this.transaction('rw', this.tags, async () => {
                if ((await this.tags.where({title: title, parent: parent}).count()) === 0) {
                    let id = await this.tags.add({title: title, parent: parent});
                    resolve({
                        id: id,
                        title: title,
                        parent: parent
                    });
                }
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    remove(id) {
        this.transaction('rw', this.tags, async() => {
            await this.tags.where("id").equals(id).delete();
        }).catch(e => {
            alert(e.stack || e);
        });
    }
}
